// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/SF-Pro-Text-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/SF-Pro-Text-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/SF-Pro-Text-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/SF-Pro-Text-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/SF-Pro-Text-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/SF-Pro-Text-Heavy.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "f-300";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "f-400";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "f-500";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "f-600";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "f-700";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: "f-800";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.text-10-400 {
  font-size: 10px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-10-500 {
  font-size: 10px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-10-600 {
  font-size: 10px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-10-700 {
  font-size: 10px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-10-800 {
  font-size: 10px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.text-11-400 {
  font-size: 11px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-11-500 {
  font-size: 11px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-11-600 {
  font-size: 11px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-11-700 {
  font-size: 11px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-11-800 {
  font-size: 11px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.text-12-400 {
  font-size: 12px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-12-500 {
  font-size: 12px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-12-600 {
  font-size: 12px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-12-700 {
  font-size: 12px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-12-800 {
  font-size: 12px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.text-13-400 {
  font-size: 13px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-13-500 {
  font-size: 13px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-13-600 {
  font-size: 13px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-13-700 {
  font-size: 13px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-13-800 {
  font-size: 13px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.text-14-400 {
  font-size: 14px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-14-500 {
  font-size: 14px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-14-600 {
  font-size: 14px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-14-700 {
  font-size: 14px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-14-800 {
  font-size: 14px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.text-15-400 {
  font-size: 15px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-15-500 {
  font-size: 15px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-15-600 {
  font-size: 15px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-15-700 {
  font-size: 15px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-15-800 {
  font-size: 15px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.text-16-400 {
  font-size: 16px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-16-500 {
  font-size: 16px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-16-600 {
  font-size: 16px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-16-700 {
  font-size: 16px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-16-800 {
  font-size: 16px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.text-17-400 {
  font-size: 17px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-17-500 {
  font-size: 17px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-17-600 {
  font-size: 17px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-17-700 {
  font-size: 17px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-17-800 {
  font-size: 17px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.text-18-400 {
  font-size: 18px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-18-500 {
  font-size: 18px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-18-600 {
  font-size: 18px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-18-700 {
  font-size: 18px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-18-800 {
  font-size: 18px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.text-19-400 {
  font-size: 19px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-19-500 {
  font-size: 19px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-19-600 {
  font-size: 19px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-19-700 {
  font-size: 19px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-19-800 {
  font-size: 19px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.text-20-400 {
  font-size: 20px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-20-500 {
  font-size: 20px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-20-600 {
  font-size: 20px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-20-700 {
  font-size: 20px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-20-800 {
  font-size: 20px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.text-22-400 {
  font-size: 22px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-22-500 {
  font-size: 22px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-22-600 {
  font-size: 22px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-22-700 {
  font-size: 22px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-22-800 {
  font-size: 22px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.text-24-400 {
  font-size: 24px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-24-500 {
  font-size: 24px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-24-600 {
  font-size: 24px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-24-700 {
  font-size: 24px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-24-800 {
  font-size: 24px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.text-25-400 {
  font-size: 25px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-25-500 {
  font-size: 25px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-25-600 {
  font-size: 25px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-25-700 {
  font-size: 25px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-25-800 {
  font-size: 25px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.text-26-400 {
  font-size: 26px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-26-500 {
  font-size: 26px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-26-600 {
  font-size: 26px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-26-700 {
  font-size: 26px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-26-800 {
  font-size: 26px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.text-29-400 {
  font-size: 29px !important;
  font-family: "f-400";
  font-weight: 400 !important;
}

.text-29-500 {
  font-size: 29px !important;
  font-family: "f-500";
  font-weight: 500 !important;
}

.text-29-600 {
  font-size: 29px !important;
  font-family: "f-600";
  font-weight: 600 !important;
}

.text-29-700 {
  font-size: 29px !important;
  font-family: "f-700";
  font-weight: 700 !important;
}

.text-29-800 {
  font-size: 29px !important;
  font-family: "f-800";
  font-weight: 800 !important;
}

.cp-5 {
  padding: 5px !important;
}

.cps-5 {
  padding-left: 5px !important;
}

.cpe-5 {
  padding-right: 5px !important;
}

.cpt-5 {
  padding-top: 5px !important;
}

.cpb-5 {
  padding-bottom: 5px !important;
}

.cm-5 {
  margin: 5px !important;
}

.cms-5 {
  margin-left: 5px !important;
}

.cme-5 {
  margin-right: 5px !important;
}

.cmt-5 {
  margin-top: 5px !important;
}

.cmb-5 {
  margin-bottom: 5px !important;
}

.cp-8 {
  padding: 8px !important;
}

.cps-8 {
  padding-left: 8px !important;
}

.cpe-8 {
  padding-right: 8px !important;
}

.cpt-8 {
  padding-top: 8px !important;
}

.cpb-8 {
  padding-bottom: 8px !important;
}

.cm-8 {
  margin: 8px !important;
}

.cms-8 {
  margin-left: 8px !important;
}

.cme-8 {
  margin-right: 8px !important;
}

.cmt-8 {
  margin-top: 8px !important;
}

.cmb-8 {
  margin-bottom: 8px !important;
}

.cp-10 {
  padding: 10px !important;
}

.cps-10 {
  padding-left: 10px !important;
}

.cpe-10 {
  padding-right: 10px !important;
}

.cpt-10 {
  padding-top: 10px !important;
}

.cpb-10 {
  padding-bottom: 10px !important;
}

.cm-10 {
  margin: 10px !important;
}

.cms-10 {
  margin-left: 10px !important;
}

.cme-10 {
  margin-right: 10px !important;
}

.cmt-10 {
  margin-top: 10px !important;
}

.cmb-10 {
  margin-bottom: 10px !important;
}

.cp-14 {
  padding: 14px !important;
}

.cps-14 {
  padding-left: 14px !important;
}

.cpe-14 {
  padding-right: 14px !important;
}

.cpt-14 {
  padding-top: 14px !important;
}

.cpb-14 {
  padding-bottom: 14px !important;
}

.cm-14 {
  margin: 14px !important;
}

.cms-14 {
  margin-left: 14px !important;
}

.cme-14 {
  margin-right: 14px !important;
}

.cmt-14 {
  margin-top: 14px !important;
}

.cmb-14 {
  margin-bottom: 14px !important;
}

.cp-15 {
  padding: 15px !important;
}

.cps-15 {
  padding-left: 15px !important;
}

.cpe-15 {
  padding-right: 15px !important;
}

.cpt-15 {
  padding-top: 15px !important;
}

.cpb-15 {
  padding-bottom: 15px !important;
}

.cm-15 {
  margin: 15px !important;
}

.cms-15 {
  margin-left: 15px !important;
}

.cme-15 {
  margin-right: 15px !important;
}

.cmt-15 {
  margin-top: 15px !important;
}

.cmb-15 {
  margin-bottom: 15px !important;
}

.cp-18 {
  padding: 18px !important;
}

.cps-18 {
  padding-left: 18px !important;
}

.cpe-18 {
  padding-right: 18px !important;
}

.cpt-18 {
  padding-top: 18px !important;
}

.cpb-18 {
  padding-bottom: 18px !important;
}

.cm-18 {
  margin: 18px !important;
}

.cms-18 {
  margin-left: 18px !important;
}

.cme-18 {
  margin-right: 18px !important;
}

.cmt-18 {
  margin-top: 18px !important;
}

.cmb-18 {
  margin-bottom: 18px !important;
}

.cp-20 {
  padding: 20px !important;
}

.cps-20 {
  padding-left: 20px !important;
}

.cpe-20 {
  padding-right: 20px !important;
}

.cpt-20 {
  padding-top: 20px !important;
}

.cpb-20 {
  padding-bottom: 20px !important;
}

.cm-20 {
  margin: 20px !important;
}

.cms-20 {
  margin-left: 20px !important;
}

.cme-20 {
  margin-right: 20px !important;
}

.cmt-20 {
  margin-top: 20px !important;
}

.cmb-20 {
  margin-bottom: 20px !important;
}

.cp-22 {
  padding: 22px !important;
}

.cps-22 {
  padding-left: 22px !important;
}

.cpe-22 {
  padding-right: 22px !important;
}

.cpt-22 {
  padding-top: 22px !important;
}

.cpb-22 {
  padding-bottom: 22px !important;
}

.cm-22 {
  margin: 22px !important;
}

.cms-22 {
  margin-left: 22px !important;
}

.cme-22 {
  margin-right: 22px !important;
}

.cmt-22 {
  margin-top: 22px !important;
}

.cmb-22 {
  margin-bottom: 22px !important;
}

.cp-24 {
  padding: 24px !important;
}

.cps-24 {
  padding-left: 24px !important;
}

.cpe-24 {
  padding-right: 24px !important;
}

.cpt-24 {
  padding-top: 24px !important;
}

.cpb-24 {
  padding-bottom: 24px !important;
}

.cm-24 {
  margin: 24px !important;
}

.cms-24 {
  margin-left: 24px !important;
}

.cme-24 {
  margin-right: 24px !important;
}

.cmt-24 {
  margin-top: 24px !important;
}

.cmb-24 {
  margin-bottom: 24px !important;
}

.cp-25 {
  padding: 25px !important;
}

.cps-25 {
  padding-left: 25px !important;
}

.cpe-25 {
  padding-right: 25px !important;
}

.cpt-25 {
  padding-top: 25px !important;
}

.cpb-25 {
  padding-bottom: 25px !important;
}

.cm-25 {
  margin: 25px !important;
}

.cms-25 {
  margin-left: 25px !important;
}

.cme-25 {
  margin-right: 25px !important;
}

.cmt-25 {
  margin-top: 25px !important;
}

.cmb-25 {
  margin-bottom: 25px !important;
}

.cp-26 {
  padding: 26px !important;
}

.cps-26 {
  padding-left: 26px !important;
}

.cpe-26 {
  padding-right: 26px !important;
}

.cpt-26 {
  padding-top: 26px !important;
}

.cpb-26 {
  padding-bottom: 26px !important;
}

.cm-26 {
  margin: 26px !important;
}

.cms-26 {
  margin-left: 26px !important;
}

.cme-26 {
  margin-right: 26px !important;
}

.cmt-26 {
  margin-top: 26px !important;
}

.cmb-26 {
  margin-bottom: 26px !important;
}

.cp-28 {
  padding: 28px !important;
}

.cps-28 {
  padding-left: 28px !important;
}

.cpe-28 {
  padding-right: 28px !important;
}

.cpt-28 {
  padding-top: 28px !important;
}

.cpb-28 {
  padding-bottom: 28px !important;
}

.cm-28 {
  margin: 28px !important;
}

.cms-28 {
  margin-left: 28px !important;
}

.cme-28 {
  margin-right: 28px !important;
}

.cmt-28 {
  margin-top: 28px !important;
}

.cmb-28 {
  margin-bottom: 28px !important;
}

.cp-30 {
  padding: 30px !important;
}

.cps-30 {
  padding-left: 30px !important;
}

.cpe-30 {
  padding-right: 30px !important;
}

.cpt-30 {
  padding-top: 30px !important;
}

.cpb-30 {
  padding-bottom: 30px !important;
}

.cm-30 {
  margin: 30px !important;
}

.cms-30 {
  margin-left: 30px !important;
}

.cme-30 {
  margin-right: 30px !important;
}

.cmt-30 {
  margin-top: 30px !important;
}

.cmb-30 {
  margin-bottom: 30px !important;
}

.cp-32 {
  padding: 32px !important;
}

.cps-32 {
  padding-left: 32px !important;
}

.cpe-32 {
  padding-right: 32px !important;
}

.cpt-32 {
  padding-top: 32px !important;
}

.cpb-32 {
  padding-bottom: 32px !important;
}

.cm-32 {
  margin: 32px !important;
}

.cms-32 {
  margin-left: 32px !important;
}

.cme-32 {
  margin-right: 32px !important;
}

.cmt-32 {
  margin-top: 32px !important;
}

.cmb-32 {
  margin-bottom: 32px !important;
}

.cp-34 {
  padding: 34px !important;
}

.cps-34 {
  padding-left: 34px !important;
}

.cpe-34 {
  padding-right: 34px !important;
}

.cpt-34 {
  padding-top: 34px !important;
}

.cpb-34 {
  padding-bottom: 34px !important;
}

.cm-34 {
  margin: 34px !important;
}

.cms-34 {
  margin-left: 34px !important;
}

.cme-34 {
  margin-right: 34px !important;
}

.cmt-34 {
  margin-top: 34px !important;
}

.cmb-34 {
  margin-bottom: 34px !important;
}

.cp-36 {
  padding: 36px !important;
}

.cps-36 {
  padding-left: 36px !important;
}

.cpe-36 {
  padding-right: 36px !important;
}

.cpt-36 {
  padding-top: 36px !important;
}

.cpb-36 {
  padding-bottom: 36px !important;
}

.cm-36 {
  margin: 36px !important;
}

.cms-36 {
  margin-left: 36px !important;
}

.cme-36 {
  margin-right: 36px !important;
}

.cmt-36 {
  margin-top: 36px !important;
}

.cmb-36 {
  margin-bottom: 36px !important;
}

.cp-38 {
  padding: 38px !important;
}

.cps-38 {
  padding-left: 38px !important;
}

.cpe-38 {
  padding-right: 38px !important;
}

.cpt-38 {
  padding-top: 38px !important;
}

.cpb-38 {
  padding-bottom: 38px !important;
}

.cm-38 {
  margin: 38px !important;
}

.cms-38 {
  margin-left: 38px !important;
}

.cme-38 {
  margin-right: 38px !important;
}

.cmt-38 {
  margin-top: 38px !important;
}

.cmb-38 {
  margin-bottom: 38px !important;
}

.cp-40 {
  padding: 40px !important;
}

.cps-40 {
  padding-left: 40px !important;
}

.cpe-40 {
  padding-right: 40px !important;
}

.cpt-40 {
  padding-top: 40px !important;
}

.cpb-40 {
  padding-bottom: 40px !important;
}

.cm-40 {
  margin: 40px !important;
}

.cms-40 {
  margin-left: 40px !important;
}

.cme-40 {
  margin-right: 40px !important;
}

.cmt-40 {
  margin-top: 40px !important;
}

.cmb-40 {
  margin-bottom: 40px !important;
}

.cp-45 {
  padding: 45px !important;
}

.cps-45 {
  padding-left: 45px !important;
}

.cpe-45 {
  padding-right: 45px !important;
}

.cpt-45 {
  padding-top: 45px !important;
}

.cpb-45 {
  padding-bottom: 45px !important;
}

.cm-45 {
  margin: 45px !important;
}

.cms-45 {
  margin-left: 45px !important;
}

.cme-45 {
  margin-right: 45px !important;
}

.cmt-45 {
  margin-top: 45px !important;
}

.cmb-45 {
  margin-bottom: 45px !important;
}

.cp-50 {
  padding: 50px !important;
}

.cps-50 {
  padding-left: 50px !important;
}

.cpe-50 {
  padding-right: 50px !important;
}

.cpt-50 {
  padding-top: 50px !important;
}

.cpb-50 {
  padding-bottom: 50px !important;
}

.cm-50 {
  margin: 50px !important;
}

.cms-50 {
  margin-left: 50px !important;
}

.cme-50 {
  margin-right: 50px !important;
}

.cmt-50 {
  margin-top: 50px !important;
}

.cmb-50 {
  margin-bottom: 50px !important;
}

.cp-60 {
  padding: 60px !important;
}

.cps-60 {
  padding-left: 60px !important;
}

.cpe-60 {
  padding-right: 60px !important;
}

.cpt-60 {
  padding-top: 60px !important;
}

.cpb-60 {
  padding-bottom: 60px !important;
}

.cm-60 {
  margin: 60px !important;
}

.cms-60 {
  margin-left: 60px !important;
}

.cme-60 {
  margin-right: 60px !important;
}

.cmt-60 {
  margin-top: 60px !important;
}

.cmb-60 {
  margin-bottom: 60px !important;
}

.cp-70 {
  padding: 70px !important;
}

.cps-70 {
  padding-left: 70px !important;
}

.cpe-70 {
  padding-right: 70px !important;
}

.cpt-70 {
  padding-top: 70px !important;
}

.cpb-70 {
  padding-bottom: 70px !important;
}

.cm-70 {
  margin: 70px !important;
}

.cms-70 {
  margin-left: 70px !important;
}

.cme-70 {
  margin-right: 70px !important;
}

.cmt-70 {
  margin-top: 70px !important;
}

.cmb-70 {
  margin-bottom: 70px !important;
}

.cp-80 {
  padding: 80px !important;
}

.cps-80 {
  padding-left: 80px !important;
}

.cpe-80 {
  padding-right: 80px !important;
}

.cpt-80 {
  padding-top: 80px !important;
}

.cpb-80 {
  padding-bottom: 80px !important;
}

.cm-80 {
  margin: 80px !important;
}

.cms-80 {
  margin-left: 80px !important;
}

.cme-80 {
  margin-right: 80px !important;
}

.cmt-80 {
  margin-top: 80px !important;
}

.cmb-80 {
  margin-bottom: 80px !important;
}

.cp-90 {
  padding: 90px !important;
}

.cps-90 {
  padding-left: 90px !important;
}

.cpe-90 {
  padding-right: 90px !important;
}

.cpt-90 {
  padding-top: 90px !important;
}

.cpb-90 {
  padding-bottom: 90px !important;
}

.cm-90 {
  margin: 90px !important;
}

.cms-90 {
  margin-left: 90px !important;
}

.cme-90 {
  margin-right: 90px !important;
}

.cmt-90 {
  margin-top: 90px !important;
}

.cmb-90 {
  margin-bottom: 90px !important;
}

.h-10 {
  height: 10px !important;
  min-height: 10px !important;
}

.w-10 {
  width: 10px !important;
}

.h-14 {
  height: 14px !important;
  min-height: 14px !important;
}

.w-14 {
  width: 14px !important;
}

.h-15 {
  height: 15px !important;
  min-height: 15px !important;
}

.w-15 {
  width: 15px !important;
}

.h-16 {
  height: 16px !important;
  min-height: 16px !important;
}

.w-16 {
  width: 16px !important;
}

.h-20 {
  height: 20px !important;
  min-height: 20px !important;
}

.w-20 {
  width: 20px !important;
}

.h-22 {
  height: 22px !important;
  min-height: 22px !important;
}

.w-22 {
  width: 22px !important;
}

.h-26 {
  height: 26px !important;
  min-height: 26px !important;
}

.w-26 {
  width: 26px !important;
}

.h-30 {
  height: 30px !important;
  min-height: 30px !important;
}

.w-30 {
  width: 30px !important;
}

.h-35 {
  height: 35px !important;
  min-height: 35px !important;
}

.w-35 {
  width: 35px !important;
}

.h-40 {
  height: 40px !important;
  min-height: 40px !important;
}

.w-40 {
  width: 40px !important;
}

.h-45 {
  height: 45px !important;
  min-height: 45px !important;
}

.w-45 {
  width: 45px !important;
}

.h-47 {
  height: 47px !important;
  min-height: 47px !important;
}

.w-47 {
  width: 47px !important;
}

.h-55 {
  height: 55px !important;
  min-height: 55px !important;
}

.w-55 {
  width: 55px !important;
}

.h-70 {
  height: 70px !important;
  min-height: 70px !important;
}

.w-70 {
  width: 70px !important;
}

.h-90 {
  height: 90px !important;
  min-height: 90px !important;
}

.w-90 {
  width: 90px !important;
}

.h-99 {
  height: 99px !important;
  min-height: 99px !important;
}

.w-99 {
  width: 99px !important;
}

.h-124 {
  height: 124px !important;
  min-height: 124px !important;
}

.w-124 {
  width: 124px !important;
}

.h-130 {
  height: 130px !important;
  min-height: 130px !important;
}

.w-130 {
  width: 130px !important;
}

.h-150 {
  height: 150px !important;
  min-height: 150px !important;
}

.w-150 {
  width: 150px !important;
}

.h-154 {
  height: 154px !important;
  min-height: 154px !important;
}

.w-154 {
  width: 154px !important;
}

.h-162 {
  height: 162px !important;
  min-height: 162px !important;
}

.w-162 {
  width: 162px !important;
}

.h-175 {
  height: 175px !important;
  min-height: 175px !important;
}

.w-175 {
  width: 175px !important;
}

.h-186 {
  height: 186px !important;
  min-height: 186px !important;
}

.w-186 {
  width: 186px !important;
}

.h-192 {
  height: 192px !important;
  min-height: 192px !important;
}

.w-192 {
  width: 192px !important;
}

.h-200 {
  height: 200px !important;
  min-height: 200px !important;
}

.w-200 {
  width: 200px !important;
}

.h-277 {
  height: 277px !important;
  min-height: 277px !important;
}

.w-277 {
  width: 277px !important;
}

.h-300 {
  height: 300px !important;
  min-height: 300px !important;
}

.w-300 {
  width: 300px !important;
}

.h-320 {
  height: 320px !important;
  min-height: 320px !important;
}

.w-320 {
  width: 320px !important;
}

.h-450 {
  height: 450px !important;
  min-height: 450px !important;
}

.w-450 {
  width: 450px !important;
}

.h-500 {
  height: 500px !important;
  min-height: 500px !important;
}

.w-500 {
  width: 500px !important;
}

.h-575 {
  height: 575px !important;
  min-height: 575px !important;
}

.w-575 {
  width: 575px !important;
}

.h-900 {
  height: 900px !important;
  min-height: 900px !important;
}

.w-900 {
  width: 900px !important;
}

.h-1064 {
  height: 1064px !important;
  min-height: 1064px !important;
}

.w-1064 {
  width: 1064px !important;
}

.input-error {
  font-size: 14px;
  font-weight: 400;
  color: var(--dc35);
}

.custom-scroll::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px transparent;
  background-color: var(--ffff);
  border-radius: 10px;
}
.custom-scroll::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: var(--ffff);
  scrollbar-width: 5px;
}
.custom-scroll::-webkit-scrollbar-thumb {
  border-radius: 0px;
  background-color: var(--e3e3);
  visibility: hidden;
}
.custom-scroll:hover::-webkit-scrollbar-thumb {
  visibility: visible;
}

.custom-scroll-dark::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px transparent;
  background-color: var(--2b4e);
  border-radius: 10px;
}
.custom-scroll-dark::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: var(--2b4e);
  scrollbar-width: 5px;
}
.custom-scroll-dark::-webkit-scrollbar-thumb {
  border-radius: 0px;
  background-color: var(--4d6c);
  visibility: hidden;
}
.custom-scroll-dark:hover::-webkit-scrollbar-thumb {
  visibility: visible;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/typography.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,4CAAA;AACF;AACA;EACE,oBAAA;EACA,4CAAA;AACF;AACA;EACE,oBAAA;EACA,4CAAA;AACF;AACA;EACE,oBAAA;EACA,4CAAA;AACF;AACA;EACE,oBAAA;EACA,4CAAA;AACF;AACA;EACE,oBAAA;EACA,4CAAA;AACF;AAYI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAHF;;AAOI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAGF;;AACI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AASF;;AALI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAeF;;AAXI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAqBF;;AAjBI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA2BF;;AAvBI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAiCF;;AA7BI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAuCF;;AAnCI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA6CF;;AAzCI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAmDF;;AA/CI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAyDF;;AArDI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA+DF;;AA3DI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAqEF;;AAjEI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA2EF;;AAvEI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAiFF;;AA7EI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAuFF;;AAnFI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA6FF;;AAzFI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAmGF;;AA/FI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAyGF;;AArGI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA+GF;;AA3GI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAqHF;;AAjHI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA2HF;;AAvHI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAiIF;;AA7HI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAuIF;;AAnII;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA6IF;;AAzII;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAmJF;;AA/II;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAyJF;;AArJI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA+JF;;AA3JI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAqKF;;AAjKI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA2KF;;AAvKI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAiLF;;AA7KI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAuLF;;AAnLI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA6LF;;AAzLI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAmMF;;AA/LI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAyMF;;AArMI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA+MF;;AA3MI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAqNF;;AAjNI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA2NF;;AAvNI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAiOF;;AA7NI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAuOF;;AAnOI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA6OF;;AAzOI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAmPF;;AA/OI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAyPF;;AArPI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA+PF;;AA3PI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAqQF;;AAjQI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA2QF;;AAvQI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAiRF;;AA7QI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAuRF;;AAnRI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA6RF;;AAzRI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAmSF;;AA/RI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAySF;;AArSI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA+SF;;AA3SI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAqTF;;AAjTI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA2TF;;AAvTI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAiUF;;AA7TI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAuUF;;AAnUI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA6UF;;AAzUI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAmVF;;AA/UI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAyVF;;AArVI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA+VF;;AA3VI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAqWF;;AAjWI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA2WF;;AAvWI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAiXF;;AA7WI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAuXF;;AAnXI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA6XF;;AAzXI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAmYF;;AA/XI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAyYF;;AArYI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA+YF;;AA3YI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAqZF;;AAjZI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA2ZF;;AAvZI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAiaF;;AA7ZI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAuaF;;AAnaI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA6aF;;AAzaI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAmbF;;AA/aI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAybF;;AArbI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA+bF;;AA3bI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAqcF;;AAjcI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AA2cF;;AAvcI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAidF;;AA7cI;EANF,0BAAA;EACA,oBAAA;EACA,2BAAA;AAudF;;AAzcE;EACE,uBAAA;AA4cJ;;AA1cE;EACE,4BAAA;AA6cJ;;AA3cE;EACE,6BAAA;AA8cJ;;AA5cE;EACE,2BAAA;AA+cJ;;AA7cE;EACE,8BAAA;AAgdJ;;AA7cE;EACE,sBAAA;AAgdJ;;AA9cE;EACE,2BAAA;AAidJ;;AA/cE;EACE,4BAAA;AAkdJ;;AAhdE;EACE,0BAAA;AAmdJ;;AAjdE;EACE,6BAAA;AAodJ;;AAjfE;EACE,uBAAA;AAofJ;;AAlfE;EACE,4BAAA;AAqfJ;;AAnfE;EACE,6BAAA;AAsfJ;;AApfE;EACE,2BAAA;AAufJ;;AArfE;EACE,8BAAA;AAwfJ;;AArfE;EACE,sBAAA;AAwfJ;;AAtfE;EACE,2BAAA;AAyfJ;;AAvfE;EACE,4BAAA;AA0fJ;;AAxfE;EACE,0BAAA;AA2fJ;;AAzfE;EACE,6BAAA;AA4fJ;;AAzhBE;EACE,wBAAA;AA4hBJ;;AA1hBE;EACE,6BAAA;AA6hBJ;;AA3hBE;EACE,8BAAA;AA8hBJ;;AA5hBE;EACE,4BAAA;AA+hBJ;;AA7hBE;EACE,+BAAA;AAgiBJ;;AA7hBE;EACE,uBAAA;AAgiBJ;;AA9hBE;EACE,4BAAA;AAiiBJ;;AA/hBE;EACE,6BAAA;AAkiBJ;;AAhiBE;EACE,2BAAA;AAmiBJ;;AAjiBE;EACE,8BAAA;AAoiBJ;;AAjkBE;EACE,wBAAA;AAokBJ;;AAlkBE;EACE,6BAAA;AAqkBJ;;AAnkBE;EACE,8BAAA;AAskBJ;;AApkBE;EACE,4BAAA;AAukBJ;;AArkBE;EACE,+BAAA;AAwkBJ;;AArkBE;EACE,uBAAA;AAwkBJ;;AAtkBE;EACE,4BAAA;AAykBJ;;AAvkBE;EACE,6BAAA;AA0kBJ;;AAxkBE;EACE,2BAAA;AA2kBJ;;AAzkBE;EACE,8BAAA;AA4kBJ;;AAzmBE;EACE,wBAAA;AA4mBJ;;AA1mBE;EACE,6BAAA;AA6mBJ;;AA3mBE;EACE,8BAAA;AA8mBJ;;AA5mBE;EACE,4BAAA;AA+mBJ;;AA7mBE;EACE,+BAAA;AAgnBJ;;AA7mBE;EACE,uBAAA;AAgnBJ;;AA9mBE;EACE,4BAAA;AAinBJ;;AA/mBE;EACE,6BAAA;AAknBJ;;AAhnBE;EACE,2BAAA;AAmnBJ;;AAjnBE;EACE,8BAAA;AAonBJ;;AAjpBE;EACE,wBAAA;AAopBJ;;AAlpBE;EACE,6BAAA;AAqpBJ;;AAnpBE;EACE,8BAAA;AAspBJ;;AAppBE;EACE,4BAAA;AAupBJ;;AArpBE;EACE,+BAAA;AAwpBJ;;AArpBE;EACE,uBAAA;AAwpBJ;;AAtpBE;EACE,4BAAA;AAypBJ;;AAvpBE;EACE,6BAAA;AA0pBJ;;AAxpBE;EACE,2BAAA;AA2pBJ;;AAzpBE;EACE,8BAAA;AA4pBJ;;AAzrBE;EACE,wBAAA;AA4rBJ;;AA1rBE;EACE,6BAAA;AA6rBJ;;AA3rBE;EACE,8BAAA;AA8rBJ;;AA5rBE;EACE,4BAAA;AA+rBJ;;AA7rBE;EACE,+BAAA;AAgsBJ;;AA7rBE;EACE,uBAAA;AAgsBJ;;AA9rBE;EACE,4BAAA;AAisBJ;;AA/rBE;EACE,6BAAA;AAksBJ;;AAhsBE;EACE,2BAAA;AAmsBJ;;AAjsBE;EACE,8BAAA;AAosBJ;;AAjuBE;EACE,wBAAA;AAouBJ;;AAluBE;EACE,6BAAA;AAquBJ;;AAnuBE;EACE,8BAAA;AAsuBJ;;AApuBE;EACE,4BAAA;AAuuBJ;;AAruBE;EACE,+BAAA;AAwuBJ;;AAruBE;EACE,uBAAA;AAwuBJ;;AAtuBE;EACE,4BAAA;AAyuBJ;;AAvuBE;EACE,6BAAA;AA0uBJ;;AAxuBE;EACE,2BAAA;AA2uBJ;;AAzuBE;EACE,8BAAA;AA4uBJ;;AAzwBE;EACE,wBAAA;AA4wBJ;;AA1wBE;EACE,6BAAA;AA6wBJ;;AA3wBE;EACE,8BAAA;AA8wBJ;;AA5wBE;EACE,4BAAA;AA+wBJ;;AA7wBE;EACE,+BAAA;AAgxBJ;;AA7wBE;EACE,uBAAA;AAgxBJ;;AA9wBE;EACE,4BAAA;AAixBJ;;AA/wBE;EACE,6BAAA;AAkxBJ;;AAhxBE;EACE,2BAAA;AAmxBJ;;AAjxBE;EACE,8BAAA;AAoxBJ;;AAjzBE;EACE,wBAAA;AAozBJ;;AAlzBE;EACE,6BAAA;AAqzBJ;;AAnzBE;EACE,8BAAA;AAszBJ;;AApzBE;EACE,4BAAA;AAuzBJ;;AArzBE;EACE,+BAAA;AAwzBJ;;AArzBE;EACE,uBAAA;AAwzBJ;;AAtzBE;EACE,4BAAA;AAyzBJ;;AAvzBE;EACE,6BAAA;AA0zBJ;;AAxzBE;EACE,2BAAA;AA2zBJ;;AAzzBE;EACE,8BAAA;AA4zBJ;;AAz1BE;EACE,wBAAA;AA41BJ;;AA11BE;EACE,6BAAA;AA61BJ;;AA31BE;EACE,8BAAA;AA81BJ;;AA51BE;EACE,4BAAA;AA+1BJ;;AA71BE;EACE,+BAAA;AAg2BJ;;AA71BE;EACE,uBAAA;AAg2BJ;;AA91BE;EACE,4BAAA;AAi2BJ;;AA/1BE;EACE,6BAAA;AAk2BJ;;AAh2BE;EACE,2BAAA;AAm2BJ;;AAj2BE;EACE,8BAAA;AAo2BJ;;AAj4BE;EACE,wBAAA;AAo4BJ;;AAl4BE;EACE,6BAAA;AAq4BJ;;AAn4BE;EACE,8BAAA;AAs4BJ;;AAp4BE;EACE,4BAAA;AAu4BJ;;AAr4BE;EACE,+BAAA;AAw4BJ;;AAr4BE;EACE,uBAAA;AAw4BJ;;AAt4BE;EACE,4BAAA;AAy4BJ;;AAv4BE;EACE,6BAAA;AA04BJ;;AAx4BE;EACE,2BAAA;AA24BJ;;AAz4BE;EACE,8BAAA;AA44BJ;;AAz6BE;EACE,wBAAA;AA46BJ;;AA16BE;EACE,6BAAA;AA66BJ;;AA36BE;EACE,8BAAA;AA86BJ;;AA56BE;EACE,4BAAA;AA+6BJ;;AA76BE;EACE,+BAAA;AAg7BJ;;AA76BE;EACE,uBAAA;AAg7BJ;;AA96BE;EACE,4BAAA;AAi7BJ;;AA/6BE;EACE,6BAAA;AAk7BJ;;AAh7BE;EACE,2BAAA;AAm7BJ;;AAj7BE;EACE,8BAAA;AAo7BJ;;AAj9BE;EACE,wBAAA;AAo9BJ;;AAl9BE;EACE,6BAAA;AAq9BJ;;AAn9BE;EACE,8BAAA;AAs9BJ;;AAp9BE;EACE,4BAAA;AAu9BJ;;AAr9BE;EACE,+BAAA;AAw9BJ;;AAr9BE;EACE,uBAAA;AAw9BJ;;AAt9BE;EACE,4BAAA;AAy9BJ;;AAv9BE;EACE,6BAAA;AA09BJ;;AAx9BE;EACE,2BAAA;AA29BJ;;AAz9BE;EACE,8BAAA;AA49BJ;;AAz/BE;EACE,wBAAA;AA4/BJ;;AA1/BE;EACE,6BAAA;AA6/BJ;;AA3/BE;EACE,8BAAA;AA8/BJ;;AA5/BE;EACE,4BAAA;AA+/BJ;;AA7/BE;EACE,+BAAA;AAggCJ;;AA7/BE;EACE,uBAAA;AAggCJ;;AA9/BE;EACE,4BAAA;AAigCJ;;AA//BE;EACE,6BAAA;AAkgCJ;;AAhgCE;EACE,2BAAA;AAmgCJ;;AAjgCE;EACE,8BAAA;AAogCJ;;AAjiCE;EACE,wBAAA;AAoiCJ;;AAliCE;EACE,6BAAA;AAqiCJ;;AAniCE;EACE,8BAAA;AAsiCJ;;AApiCE;EACE,4BAAA;AAuiCJ;;AAriCE;EACE,+BAAA;AAwiCJ;;AAriCE;EACE,uBAAA;AAwiCJ;;AAtiCE;EACE,4BAAA;AAyiCJ;;AAviCE;EACE,6BAAA;AA0iCJ;;AAxiCE;EACE,2BAAA;AA2iCJ;;AAziCE;EACE,8BAAA;AA4iCJ;;AAzkCE;EACE,wBAAA;AA4kCJ;;AA1kCE;EACE,6BAAA;AA6kCJ;;AA3kCE;EACE,8BAAA;AA8kCJ;;AA5kCE;EACE,4BAAA;AA+kCJ;;AA7kCE;EACE,+BAAA;AAglCJ;;AA7kCE;EACE,uBAAA;AAglCJ;;AA9kCE;EACE,4BAAA;AAilCJ;;AA/kCE;EACE,6BAAA;AAklCJ;;AAhlCE;EACE,2BAAA;AAmlCJ;;AAjlCE;EACE,8BAAA;AAolCJ;;AAjnCE;EACE,wBAAA;AAonCJ;;AAlnCE;EACE,6BAAA;AAqnCJ;;AAnnCE;EACE,8BAAA;AAsnCJ;;AApnCE;EACE,4BAAA;AAunCJ;;AArnCE;EACE,+BAAA;AAwnCJ;;AArnCE;EACE,uBAAA;AAwnCJ;;AAtnCE;EACE,4BAAA;AAynCJ;;AAvnCE;EACE,6BAAA;AA0nCJ;;AAxnCE;EACE,2BAAA;AA2nCJ;;AAznCE;EACE,8BAAA;AA4nCJ;;AAzpCE;EACE,wBAAA;AA4pCJ;;AA1pCE;EACE,6BAAA;AA6pCJ;;AA3pCE;EACE,8BAAA;AA8pCJ;;AA5pCE;EACE,4BAAA;AA+pCJ;;AA7pCE;EACE,+BAAA;AAgqCJ;;AA7pCE;EACE,uBAAA;AAgqCJ;;AA9pCE;EACE,4BAAA;AAiqCJ;;AA/pCE;EACE,6BAAA;AAkqCJ;;AAhqCE;EACE,2BAAA;AAmqCJ;;AAjqCE;EACE,8BAAA;AAoqCJ;;AAjsCE;EACE,wBAAA;AAosCJ;;AAlsCE;EACE,6BAAA;AAqsCJ;;AAnsCE;EACE,8BAAA;AAssCJ;;AApsCE;EACE,4BAAA;AAusCJ;;AArsCE;EACE,+BAAA;AAwsCJ;;AArsCE;EACE,uBAAA;AAwsCJ;;AAtsCE;EACE,4BAAA;AAysCJ;;AAvsCE;EACE,6BAAA;AA0sCJ;;AAxsCE;EACE,2BAAA;AA2sCJ;;AAzsCE;EACE,8BAAA;AA4sCJ;;AAzuCE;EACE,wBAAA;AA4uCJ;;AA1uCE;EACE,6BAAA;AA6uCJ;;AA3uCE;EACE,8BAAA;AA8uCJ;;AA5uCE;EACE,4BAAA;AA+uCJ;;AA7uCE;EACE,+BAAA;AAgvCJ;;AA7uCE;EACE,uBAAA;AAgvCJ;;AA9uCE;EACE,4BAAA;AAivCJ;;AA/uCE;EACE,6BAAA;AAkvCJ;;AAhvCE;EACE,2BAAA;AAmvCJ;;AAjvCE;EACE,8BAAA;AAovCJ;;AAjxCE;EACE,wBAAA;AAoxCJ;;AAlxCE;EACE,6BAAA;AAqxCJ;;AAnxCE;EACE,8BAAA;AAsxCJ;;AApxCE;EACE,4BAAA;AAuxCJ;;AArxCE;EACE,+BAAA;AAwxCJ;;AArxCE;EACE,uBAAA;AAwxCJ;;AAtxCE;EACE,4BAAA;AAyxCJ;;AAvxCE;EACE,6BAAA;AA0xCJ;;AAxxCE;EACE,2BAAA;AA2xCJ;;AAzxCE;EACE,8BAAA;AA4xCJ;;AAzzCE;EACE,wBAAA;AA4zCJ;;AA1zCE;EACE,6BAAA;AA6zCJ;;AA3zCE;EACE,8BAAA;AA8zCJ;;AA5zCE;EACE,4BAAA;AA+zCJ;;AA7zCE;EACE,+BAAA;AAg0CJ;;AA7zCE;EACE,uBAAA;AAg0CJ;;AA9zCE;EACE,4BAAA;AAi0CJ;;AA/zCE;EACE,6BAAA;AAk0CJ;;AAh0CE;EACE,2BAAA;AAm0CJ;;AAj0CE;EACE,8BAAA;AAo0CJ;;AAj2CE;EACE,wBAAA;AAo2CJ;;AAl2CE;EACE,6BAAA;AAq2CJ;;AAn2CE;EACE,8BAAA;AAs2CJ;;AAp2CE;EACE,4BAAA;AAu2CJ;;AAr2CE;EACE,+BAAA;AAw2CJ;;AAr2CE;EACE,uBAAA;AAw2CJ;;AAt2CE;EACE,4BAAA;AAy2CJ;;AAv2CE;EACE,6BAAA;AA02CJ;;AAx2CE;EACE,2BAAA;AA22CJ;;AAz2CE;EACE,8BAAA;AA42CJ;;AAn2CE;EACE,uBAAA;EACA,2BAAA;AAs2CJ;;AAp2CE;EACE,sBAAA;AAu2CJ;;AA52CE;EACE,uBAAA;EACA,2BAAA;AA+2CJ;;AA72CE;EACE,sBAAA;AAg3CJ;;AAr3CE;EACE,uBAAA;EACA,2BAAA;AAw3CJ;;AAt3CE;EACE,sBAAA;AAy3CJ;;AA93CE;EACE,uBAAA;EACA,2BAAA;AAi4CJ;;AA/3CE;EACE,sBAAA;AAk4CJ;;AAv4CE;EACE,uBAAA;EACA,2BAAA;AA04CJ;;AAx4CE;EACE,sBAAA;AA24CJ;;AAh5CE;EACE,uBAAA;EACA,2BAAA;AAm5CJ;;AAj5CE;EACE,sBAAA;AAo5CJ;;AAz5CE;EACE,uBAAA;EACA,2BAAA;AA45CJ;;AA15CE;EACE,sBAAA;AA65CJ;;AAl6CE;EACE,uBAAA;EACA,2BAAA;AAq6CJ;;AAn6CE;EACE,sBAAA;AAs6CJ;;AA36CE;EACE,uBAAA;EACA,2BAAA;AA86CJ;;AA56CE;EACE,sBAAA;AA+6CJ;;AAp7CE;EACE,uBAAA;EACA,2BAAA;AAu7CJ;;AAr7CE;EACE,sBAAA;AAw7CJ;;AA77CE;EACE,uBAAA;EACA,2BAAA;AAg8CJ;;AA97CE;EACE,sBAAA;AAi8CJ;;AAt8CE;EACE,uBAAA;EACA,2BAAA;AAy8CJ;;AAv8CE;EACE,sBAAA;AA08CJ;;AA/8CE;EACE,uBAAA;EACA,2BAAA;AAk9CJ;;AAh9CE;EACE,sBAAA;AAm9CJ;;AAx9CE;EACE,uBAAA;EACA,2BAAA;AA29CJ;;AAz9CE;EACE,sBAAA;AA49CJ;;AAj+CE;EACE,uBAAA;EACA,2BAAA;AAo+CJ;;AAl+CE;EACE,sBAAA;AAq+CJ;;AA1+CE;EACE,uBAAA;EACA,2BAAA;AA6+CJ;;AA3+CE;EACE,sBAAA;AA8+CJ;;AAn/CE;EACE,wBAAA;EACA,4BAAA;AAs/CJ;;AAp/CE;EACE,uBAAA;AAu/CJ;;AA5/CE;EACE,wBAAA;EACA,4BAAA;AA+/CJ;;AA7/CE;EACE,uBAAA;AAggDJ;;AArgDE;EACE,wBAAA;EACA,4BAAA;AAwgDJ;;AAtgDE;EACE,uBAAA;AAygDJ;;AA9gDE;EACE,wBAAA;EACA,4BAAA;AAihDJ;;AA/gDE;EACE,uBAAA;AAkhDJ;;AAvhDE;EACE,wBAAA;EACA,4BAAA;AA0hDJ;;AAxhDE;EACE,uBAAA;AA2hDJ;;AAhiDE;EACE,wBAAA;EACA,4BAAA;AAmiDJ;;AAjiDE;EACE,uBAAA;AAoiDJ;;AAziDE;EACE,wBAAA;EACA,4BAAA;AA4iDJ;;AA1iDE;EACE,uBAAA;AA6iDJ;;AAljDE;EACE,wBAAA;EACA,4BAAA;AAqjDJ;;AAnjDE;EACE,uBAAA;AAsjDJ;;AA3jDE;EACE,wBAAA;EACA,4BAAA;AA8jDJ;;AA5jDE;EACE,uBAAA;AA+jDJ;;AApkDE;EACE,wBAAA;EACA,4BAAA;AAukDJ;;AArkDE;EACE,uBAAA;AAwkDJ;;AA7kDE;EACE,wBAAA;EACA,4BAAA;AAglDJ;;AA9kDE;EACE,uBAAA;AAilDJ;;AAtlDE;EACE,wBAAA;EACA,4BAAA;AAylDJ;;AAvlDE;EACE,uBAAA;AA0lDJ;;AA/lDE;EACE,wBAAA;EACA,4BAAA;AAkmDJ;;AAhmDE;EACE,uBAAA;AAmmDJ;;AAxmDE;EACE,wBAAA;EACA,4BAAA;AA2mDJ;;AAzmDE;EACE,uBAAA;AA4mDJ;;AAjnDE;EACE,wBAAA;EACA,4BAAA;AAonDJ;;AAlnDE;EACE,uBAAA;AAqnDJ;;AA1nDE;EACE,wBAAA;EACA,4BAAA;AA6nDJ;;AA3nDE;EACE,uBAAA;AA8nDJ;;AAnoDE;EACE,yBAAA;EACA,6BAAA;AAsoDJ;;AApoDE;EACE,wBAAA;AAuoDJ;;AAnoDA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAsoDF;;AAloDE;EACE,6CAAA;EACA,6BAAA;EACA,mBAAA;AAqoDJ;AAloDE;EACE,UAAA;EACA,WAAA;EACA,6BAAA;EACA,oBAAA;AAooDJ;AAjoDE;EACE,kBAAA;EACA,6BAAA;EACA,kBAAA;AAmoDJ;AAhoDI;EACE,mBAAA;AAkoDN;;AA5nDE;EACE,6CAAA;EACA,6BAAA;EACA,mBAAA;AA+nDJ;AA5nDE;EACE,UAAA;EACA,WAAA;EACA,6BAAA;EACA,oBAAA;AA8nDJ;AA3nDE;EACE,kBAAA;EACA,6BAAA;EACA,kBAAA;AA6nDJ;AA1nDI;EACE,mBAAA;AA4nDN","sourcesContent":["@font-face {\r\n  font-family: \"f-300\";\r\n  src: url(../fonts/SF-Pro-Text-Light.otf);\r\n}\r\n@font-face {\r\n  font-family: \"f-400\";\r\n  src: url(../fonts/SF-Pro-Text-Regular.otf);\r\n}\r\n@font-face {\r\n  font-family: \"f-500\";\r\n  src: url(../fonts/SF-Pro-Text-Medium.otf);\r\n}\r\n@font-face {\r\n  font-family: \"f-600\";\r\n  src: url(../fonts/SF-Pro-Text-Semibold.otf);\r\n}\r\n@font-face {\r\n  font-family: \"f-700\";\r\n  src: url(../fonts/SF-Pro-Text-Bold.otf);\r\n}\r\n@font-face {\r\n  font-family: \"f-800\";\r\n  src: url(../fonts/SF-Pro-Text-Heavy.otf);\r\n}\r\n\r\n// Fonts\r\n$fontSizes: 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 24, 25, 26, 29;\r\n$fonthweights: 400, 500, 600, 700, 800;\r\n@mixin text-font-style($f-size, $f-weight) {\r\n  font-size: $f-size !important;\r\n  font-family: \"f-#{$f-weight}\";\r\n  font-weight: $f-weight !important;\r\n}\r\n@each $fSize in $fontSizes {\r\n  @each $fWeight in $fonthweights {\r\n    .text-#{$fSize}-#{$fWeight} {\r\n      @include text-font-style(#{$fSize}px, #{$fWeight});\r\n    }\r\n  }\r\n}\r\n\r\n// Custom Margin and Padding\r\n$sizes: 5, 8, 10, 14, 15, 18, 20, 22, 24, 25, 26, 28, 30, 32, 34, 36, 38, 40, 45,\r\n  50, 60, 70, 80, 90;\r\n@each $size in $sizes {\r\n  .cp-#{$size} {\r\n    padding: #{$size}px !important;\r\n  }\r\n  .cps-#{$size} {\r\n    padding-left: #{$size}px !important;\r\n  }\r\n  .cpe-#{$size} {\r\n    padding-right: #{$size}px !important;\r\n  }\r\n  .cpt-#{$size} {\r\n    padding-top: #{$size}px !important;\r\n  }\r\n  .cpb-#{$size} {\r\n    padding-bottom: #{$size}px !important;\r\n  }\r\n\r\n  .cm-#{$size} {\r\n    margin: #{$size}px !important;\r\n  }\r\n  .cms-#{$size} {\r\n    margin-left: #{$size}px !important;\r\n  }\r\n  .cme-#{$size} {\r\n    margin-right: #{$size}px !important;\r\n  }\r\n  .cmt-#{$size} {\r\n    margin-top: #{$size}px !important;\r\n  }\r\n  .cmb-#{$size} {\r\n    margin-bottom: #{$size}px !important;\r\n  }\r\n}\r\n\r\n// Height and width\r\n$heights: 10, 14, 15, 16, 20, 22, 26, 30, 35, 40, 45, 47, 55, 70, 90, 99, 124,\r\n  130, 150, 154, 162, 175, 186, 192, 200, 277, 300, 320, 450, 500, 575, 900,\r\n  1064;\r\n@each $height in $heights {\r\n  .h-#{$height} {\r\n    height: #{$height}px !important;\r\n    min-height: #{$height}px !important;\r\n  }\r\n  .w-#{$height} {\r\n    width: #{$height}px !important;\r\n  }\r\n}\r\n\r\n.input-error {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: var(--dc35);\r\n}\r\n\r\n.custom-scroll {\r\n  &::-webkit-scrollbar-track {\r\n    -webkit-box-shadow: inset 0 0 6px transparent;\r\n    background-color: var(--ffff);\r\n    border-radius: 10px;\r\n  }\r\n\r\n  &::-webkit-scrollbar {\r\n    width: 5px;\r\n    height: 5px;\r\n    background-color: var(--ffff);\r\n    scrollbar-width: 5px;\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    border-radius: 0px;\r\n    background-color: var(--e3e3);\r\n    visibility: hidden;\r\n  }\r\n  &:hover {\r\n    &::-webkit-scrollbar-thumb {\r\n      visibility: visible;\r\n    }\r\n  }\r\n}\r\n\r\n.custom-scroll-dark {\r\n  &::-webkit-scrollbar-track {\r\n    -webkit-box-shadow: inset 0 0 6px transparent;\r\n    background-color: var(--2b4e);\r\n    border-radius: 10px;\r\n  }\r\n\r\n  &::-webkit-scrollbar {\r\n    width: 5px;\r\n    height: 5px;\r\n    background-color: var(--2b4e);\r\n    scrollbar-width: 5px;\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    border-radius: 0px;\r\n    background-color: var(--4d6c);\r\n    visibility: hidden;\r\n  }\r\n  &:hover {\r\n    &::-webkit-scrollbar-thumb {\r\n      visibility: visible;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
